<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='文章管理' subPath='来源列表'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="2">
          <el-button type="primary" @click="showAddDialog">添加来源</el-button>
        </el-col>
      </el-row>
    </el-card>
    <el-table :data="sourceList" stripe border :cell-style="{ textAlign: 'center' }">
      <el-table-column prop="id" label="ID" align="center" width="50px"></el-table-column>
      <el-table-column prop="title" label="名称" align="center"></el-table-column>
      <el-table-column prop="domain" label="域名" align="center"></el-table-column>
      <el-table-column prop="domain_api" label="api域名" align="center"></el-table-column>
      <el-table-column prop="domain_res" label="资源域名" align="center"></el-table-column>
      <el-table-column prop="article_path" label="文章路径" align="center"></el-table-column>
      <el-table-column label="创建时间" align="center">
        <template slot-scope="scope">
          {{scope.row.create_time | dateTimeFormat}}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="290px">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
          <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="param.page"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="param.count"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    <handpick-source-add
      :visible="addDialogAvaible"
      :id="currentId"
      @add="addSource"
      @update="updateSource"
      @closeDialog="closeAddDialog">
    </handpick-source-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import handpickSourceAddVue from './handpickSourceAdd.vue'
export default {
  name: 'hankpick_source_list',
  components: {
    'bread-crumb': BreadCrumb,
    'handpick-source-add': handpickSourceAddVue
  },
  data () {
    return {
      sourceList: [],
      currentId: 0,
      total: 0,
      pageTotal: 1,
      param: {
        page: 1,
        count: 10
      },
      addDialogAvaible: false
    }
  },
  created () {
    this.getSourceList()
  },
  methods: {
    async getSourceList () {
      const res = await this.$http.get('/admin/handpick_source/list', this.param)
      if (res.code === 0) {
        this.sourceList = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getSourceList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getSourceList()
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/handpick_source/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getSourceList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    },
    async addSource (data) {
      const res = await this.$http.post('/admin/handpick_source/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getSourceList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async updateSource (id, data) {
      const res = await this.$http.post('/admin/handpick_source/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getSourceList()
      } else {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style scoped>
</style>
